export class FrontendConfig {
  constructor(inFrontendConfig) {
    this.frontendConfig = inFrontendConfig || null;
  }

  get() {
    return this.frontendConfig;
  }
}
